module.exports = __webpack_public_path__ + "img/icon-send.91b21cf3.svg";